<script>
    export let cliente = {};
    function verFecha(fecha){
        let f = new Date(fecha);
        return `${f.getDate()}/${f.getMonth()+1}/${f.getFullYear()}`;
    }
</script>
<a href={`#/cliente/${cliente._id}`} class="w-full m-2 p-2 bg-white rounded shadow flex items-center justify-between sm:w-3/4">
    <div class="flex items-center justify-center">
        <p class="text-xs font-bold">{cliente.documentos[0].abreviacion}</p>
    </div>
    <div class="flex items-center justify-center flex-col w-full">
        <p class="text-xs">{(cliente.documentos[0].cuerpo?cliente.documentos[0].cuerpo[1].nombre:"")}</p>
        <p class="text-xs">{verFecha(cliente.documentos[0].fecha)}</p>
    </div>
    <div class="flex items-center justify-center flex-col w-full">
        <p>{cliente.nombre}</p>
        <p class="text-xs">{verFecha((cliente.cumpleMenor?cliente.cumple:cliente.cumple))}</p>
    </div>
</a>